import type { Amount } from "@b2bportal/nubank-purchase-api";
import type { FormatFiatCurrencyOptions } from "@hopper-b2b/i18n";
import type { FiatPrice } from "@hopper-b2b/types";

/**
 * Checkout / NuPay totals: exact cents from quoteBreakdown.balance (2dp).
 * Used when showCombinedTotal is true on flight review and on hotel checkout CTAs.
 *
 * Shop and per-traveler CTAs keep DisplayedPrice's 0dp ceil fallback instead.
 */
export const EXACT_CHECKOUT_TOTAL_FORMAT: FormatFiatCurrencyOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

const getCurrencySymbol = (currencyCode: string): string =>
  new Intl.NumberFormat("en", { style: "currency", currency: currencyCode })
    .formatToParts(0)
    .find((part) => part.type === "currency")?.value ?? currencyCode;

export const amountToFiatPrice = (amount?: Amount): FiatPrice => ({
  value: amount?.amount ?? 0,
  currencyCode: amount?.currency ?? "BRL",
  currencySymbol: getCurrencySymbol(amount?.currency ?? "BRL"),
});
